/* WARNING Copied from main branch */
import { Pipe, PipeTransform } from '@angular/core';
import { formatNumber } from '@angular/common';

@Pipe({
	name: 'fc',
	standalone: true
})
export class FormatCurrencyPipe implements PipeTransform {
	transform(value: any, ...args: unknown[]): string {
		if (value !== undefined && value !== null && Number(value) == value) {
			value = formatNumber(value, 'fr', '1.2-2');	// First apply fr format => add thousand separator
			return value.replace(/,/g, ".");						// Use comma (.) as decimal point
		} else {
			return "NaN";
		}
	}
}

@Pipe({
	name: 'fcfse',
	standalone: true
})
export class FormatFSECurrencyPipe implements PipeTransform {
	transform(value: any, ...args: unknown[]): string {
		if (value !== undefined && value !== null && Number(value) == value) {
			value = +value/100;
			value = formatNumber(value, 'fr', '1.2-2');	// First apply fr format => add thousand separator
			return value.replace(/,/g, ".");						// Use comma (.) as decimal point
		} else {
			return "NaN";
		}
	}
}

@Pipe({
	name: 'fseToFrDateFormat',
	standalone: true
})
export class FseToFrDateFormat implements PipeTransform {
	transform(value: any, ...args: unknown[]): string {
		if (value && typeof value === 'string' && /^[0-9]{8}$/.test(value)) {
			const year = value.substring(0, 4);
			const month = value.substring(4, 6);
			const day = value.substring(6, 8);
			return `${day}/${month}/${year}`;
		} else {
			return "Invalid Date";
		}
	}
}